import { formatMoney } from "~/utils/formatMoney"

const SiteCard = ({ siteData, camp }: any) => {
  const { site_name, booked, blocked, avg_rate, revenue, available, occupancy, occupancy_without_blockers } = siteData

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-3">{site_name}</h3>

      <div className="grid grid-cols-2 gap-2">
        <div className="mb-2">
          <p className="text-sm text-gray-500">Booked nights</p>
          <p className="text-base font-medium">{booked}</p>
        </div>

        <div className="mb-2">
          <p className="text-sm text-gray-500">Blocked nights</p>
          <p className="text-base font-medium">{blocked}</p>
        </div>

        <div className="mb-2">
          <p className="text-sm text-gray-500">Available nights</p>
          <p className="text-base font-medium">{available}</p>
        </div>

        <div className="mb-2">
          <p className="text-sm text-gray-500">Avg. rate</p>
          <p className="text-base font-medium">{formatMoney(avg_rate, camp?.currency)}</p>
        </div>

        <div className="mb-2">
          <p className="text-sm text-gray-500">Occupancy (excl. blockers)</p>
          <p className="text-base font-medium">{occupancy_without_blockers}</p>
        </div>

        <div className="mb-2">
          <p className="text-sm text-gray-500">Occupancy (incl. blockers)</p>
          <p className="text-base font-medium">{occupancy}</p>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">Total Revenue</span>
          <span className="text-lg font-semibold text-gray-900">{formatMoney(revenue, camp?.currency)}</span>
        </div>
      </div>
    </div>
  )
}

export default SiteCard
